// Helper to use a Yup schema with Formik validate prop while logging all missing required fields
// Ensures abortEarly is false to collect all errors
export const makeFormikYupValidator = (yupSchema, alertFn) => {
  let lastSignature = "";
  return async (values) => {
    try {
      await yupSchema.validate(values, { abortEarly: false });
      lastSignature = "";
      return {};
    } catch (err) {
      const errors = {};
      const missingRequired = new Set();
      if (err && Array.isArray(err.inner)) {
        err.inner.forEach((e) => {
          if (e && e.path && !errors[e.path]) {
            errors[e.path] = e.message || "Validation error";
          }
          if (e && e.type === "required" && e.path) {
            missingRequired.add(e.path);
          }
        });
      } else if (err && err.path) {
        errors[err.path] = err.message || "Validation error";
        if (err.type === "required" && err.path) {
          missingRequired.add(err.path);
        }
      }
      // Alert only once per unique set of missing required fields
      const signature = Array.from(missingRequired).sort().join("|");
      if (missingRequired.size > 0 && signature !== lastSignature) {
        lastSignature = signature;
        try {
          if (typeof alertFn === "function") {
            alertFn(Array.from(missingRequired).sort());
          }
        } catch (_) {
          // swallow
        }
      }
      return errors;
    }
  };
};
